/* One shared Cairo deadline; never restarts on navigation, refresh, or a new visitor. */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('broek-offer-countdown')) return;
  class BroekOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.activeLink = this.querySelector('[data-offer-active]');
      this.endedLink = this.querySelector('[data-offer-ended]');
      this.clock = this.querySelector('[data-offer-clock]');
      this.hours = this.querySelector('[data-clock-hours]');
      this.minutes = this.querySelector('[data-clock-minutes]');
      this.seconds = this.querySelector('[data-clock-seconds]');
      this.section = this.closest('.broek-fomo-header');
      this.updateBound = this.update.bind(this);
      this.resizeBound = this.measure.bind(this);
      this.visibilityBound = () => { if (!document.hidden) this.update(); else clearTimeout(this.timer); };
      window.addEventListener('pageshow', this.updateBound);
      window.addEventListener('resize', this.resizeBound, { passive: true });
      document.addEventListener('visibilitychange', this.visibilityBound);
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.resizeBound);
        this.observer.observe(this);
      }
      this.update();
      this.measure();
    }
    measure() {
      if (!this.isConnected) return;
      const height = Math.ceil((this.section || this).getBoundingClientRect().height);
      const value = height + 'px';
      if (document.documentElement.style.getPropertyValue('--broek-offer-bar-height') !== value) {
        document.documentElement.style.setProperty('--broek-offer-bar-height', value);
      }
    }
    update() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.activeLink || !this.endedLink) return;
      const remaining = Number.isFinite(this.end) ? Math.max(0, Math.ceil((this.end - Date.now()) / 1000)) : 0;
      const active = remaining > 0;
      const hadFocus = document.activeElement === this.activeLink;
      if (this.activeLink.hidden === active) this.activeLink.hidden = !active;
      if (this.endedLink.hidden !== active) this.endedLink.hidden = active;
      if (!active) {
        if (hadFocus) this.endedLink.focus({ preventScroll: true });
        this.measure();
        return;
      }
      const hours = Math.floor(remaining / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;
      [[this.hours, hours], [this.minutes, minutes], [this.seconds, seconds]].forEach(([node, number]) => {
        const value = String(number).padStart(2, '0');
        if (node && node.textContent !== value) node.textContent = value;
      });
      if (this.clock) this.clock.setAttribute('aria-label', hours + ' hours, ' + minutes + ' minutes, ' + seconds + ' seconds remaining');
      if (!document.hidden) this.timer = window.setTimeout(this.updateBound, 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('pageshow', this.updateBound);
      window.removeEventListener('resize', this.resizeBound);
      document.removeEventListener('visibilitychange', this.visibilityBound);
      if (!document.querySelector('broek-offer-countdown')) document.documentElement.style.removeProperty('--broek-offer-bar-height');
    }
  }
  customElements.define('broek-offer-countdown', BroekOfferCountdown);
}());
